import styled, { css } from 'styled-components'
import { colors, fieldLabel, fontScope, radius } from '../tokens'

export const Wrapper = styled.section`
  ${fontScope}
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
`

export const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${colors.ink900};
`

export const Scroll = styled.div`
  overflow-x: auto;
  border: 1px solid ${colors.tableBorder};
  border-radius: ${radius.table};
  background: ${colors.white};

  @media print {
    overflow: visible;
    border-radius: 0;
  }
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.ink700};
`

const numeric = css<{ $numeric?: boolean }>`
  text-align: ${({ $numeric }) => ($numeric === true ? 'right' : 'left')};
  white-space: nowrap;
`

export const HeadCell = styled.th<{ $numeric?: boolean }>`
  ${fieldLabel}
  ${numeric}
  padding: 12px 16px;
  background: ${colors.accent};
  border-bottom: 1px solid ${colors.tableBorder};
`

export const RowHead = styled.th`
  padding: 12px 16px;
  text-align: left;
  font-weight: 600;
  color: ${colors.ink900};
  border-bottom: 1px solid ${colors.rowDivider};
`

export const Cell = styled.td<{ $numeric?: boolean }>`
  ${numeric}
  padding: 12px 16px;
  border-bottom: 1px solid ${colors.rowDivider};
  font-variant-numeric: tabular-nums;
`

export const Toggle = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  font-weight: 600;
  color: inherit;
  text-align: left;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`

export const Chevron = styled.span<{ $open: boolean }>`
  display: inline-block;
  width: 12px;
  font-size: 18px;
  line-height: 1;
  color: ${colors.ink500};
  transform: rotate(${({ $open }) => ($open ? '90deg' : '0deg')});
  transition: transform 0.15s ease;

  @media print {
    display: none;
  }
`

export const SubRow = styled.tr`
  & > th,
  & > td {
    padding-top: 6px;
    padding-bottom: 6px;
    font-size: 13px;
    font-weight: 400;
    color: ${colors.ink500};
  }

  & > th {
    padding-left: 32px;
  }
`

export const TotalRow = styled.tr`
  & > th,
  & > td {
    border-bottom: 0;
    background: ${colors.zebra};
    font-weight: 700;
    color: ${colors.ink900};
  }
`
